var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-work-in-progess-page',{attrs:{"title":"Vergleiche ETFs"}})}
var staticRenderFns = []

export { render, staticRenderFns }